import { Show, createMemo } from 'solid-js';
import { requireAttendanceGridContext } from '../st-attendance-grid';
import styles from '../st-attendance-grid.module.css';
import { Flexbox, Icon } from '../../..';
import { StudentSectionData } from '../../../api/stApp';

export function AttendanceRecord(sectData: StudentSectionData & { calDate: Date }) {
    const ctx = requireAttendanceGridContext();
    const codeInfo = createMemo(() => ctx.getAttendanceCodeInfo(sectData.absenceCode ?? ''));

    return <div class={`${styles.appointment} ${styles['attendance-record']}`} tabindex="0">
        <Flexbox dir="horizontal" middle role="presentation"
            class={`${styles.title} ${styles['attendance-record-title']}`}
            style={{
                'border-left': `4px solid ${codeInfo()?.color ?? 'gray'}`
            }}>
            <Show when={codeInfo()?.iconPath ?? codeInfo()?.iconClass}>
                <Flexbox as="span" dir="vertical" middle role="presentation"
                    class={`${styles.icon} ${styles['attendance-record-icon']}`}
                    style={{ color: codeInfo()?.color ?? 'gray' }}>
                    <Icon size={16} src={codeInfo()?.iconPath ?? codeInfo()?.iconClass ?? ''} />
                </Flexbox>
            </Show>
            <span class={`${styles.title} ${styles['attendance-record-text']} auto`}>
                 {sectData.absenceCode} - {sectData.studentName}
            </span>
        </Flexbox>
    </div>
}
